var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurveShield(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 605,
    height: 604,
    viewBox: "0 0 605 604",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M525.821 89.0361C516.766 99.1634 499.288 116.886 489.18 125.748C487.285 127.436 481.81 132.077 480.125 132.71C472.966 135.875 447.906 128.279 439.062 125.748C393.787 113.51 352.303 93.0448 309.344 74.6891C257.752 99.7964 206.58 121.528 149.934 133.132C126.559 137.985 100.658 139.462 77.9151 144.947C76.0198 145.369 71.3871 146.424 70.1236 147.479C64.2273 151.699 68.8601 180.182 69.0707 187.989C70.9659 238.625 71.1765 289.895 82.5479 339.265C105.712 439.906 154.988 524.089 234.377 590.128C246.17 599.833 292.076 633.169 304.711 635.701C317.346 638.233 347.459 617.767 358.831 609.75C444.116 550.251 502.236 463.536 532.771 364.373L596.577 300.022L605 298.545C600.578 340.531 588.785 384.416 573.834 423.66C534.455 525.777 457.172 616.501 367.043 677.265C355.882 684.86 326.19 704.271 314.187 706.803C304.501 708.913 289.76 700.263 281.126 695.621C198.999 650.47 117.715 561.645 73.2823 479.571C14.5301 371.335 3.57987 262.045 0.421151 140.517C0.210569 131.866 -0.842313 100.218 1.47408 94.3108C2.52699 91.7789 6.52805 90.302 9.05502 89.4581C115.609 78.4868 215.214 47.6828 310.397 0C380.31 32.0699 451.065 63.7178 527.717 75.955C535.719 78.6978 528.559 85.0274 525.4 88.8251L525.821 89.0361Z",
    fill: "url(#paint0_linear_1433_3925)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1433_3925",
    x1: 0.421163,
    y1: 353.824,
    x2: 605.632,
    y2: 353.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#02BEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#0A90FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#106EFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#135AFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1553FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurveShield);
export default __webpack_public_path__ + "static/media/curve-shield.6f237acc950ade882850a0a3002f1b5f.svg";
export { ForwardRef as ReactComponent };